import { BOTTOMLEGENDPANEL } from "../../actions/dashboard/";

export default function(state = false, action){
  switch (action.type) {
    case BOTTOMLEGENDPANEL:
    return action.payload;
    default:
  }

  return state;
}
